import React, {useEffect, useState} from 'react';
import {Col, Row} from 'reactstrap';
import {connect, useSelector} from "react-redux";

// components
import ActivityList from "./_list";
import {showLoader} from "../../../components/loader/loader";

// actions
import { mapFunctions } from "../../../components/map/mapFunctions";
import {getStateByPath} from "../../../redux/selectors";
import {
    ADD_STATE,
    REMOVE_STATE,
    setApp,
    setForm,
    setLoading,
    setMapConfig,
    setUdn,
    setViewMode
} from "../../../redux/actions/generics/IndexedActions";



function Activity(props) {
    const path = props.path || 'core/activity';
    const componentState = useSelector(state => getStateByPath(state, path));
    const { loading } = componentState?.data || false;

    const [isExtraordinary] = useState(false );
    const [googleConfig, setGoogleConfig] = useState(null );

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        if (props.app !== null)
            props.setApp(path, props.app);

        const udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null
        if (udn) {
            loadGoogleConfig( udn );
            props.setUdn(path, udn);
        }
    },[]);

    const loadGoogleConfig = ( _udn ) => {
        let _googleConfig = {}

        if (_udn?.id !== undefined){
            mapFunctions.loadMapConfig(_udn)
                .then(result => {
                    if (result?.data?.length > 0) {
                        let config = result?.data[0];
                        _googleConfig =  {
                            mapOptions: {
                                center: {
                                    lat: parseFloat(config?.latitude),
                                    lng: parseFloat(config?.longitude)
                                },
                                disableDefaultUI: false,
                                mapTypeControl: false,
                                rotateControl: false,
                                streetViewControl: false,
                                zoom: config.defaultZoom + 1,
                                minZoom: config.minZoom,
                                maxZoom: config.maxZoom + 3
                            },
                            overlay: {
                                udn: config.udnCode.toLowerCase(),
                                pto1: {
                                    lat: config.overlay1Lat,
                                    lng: config.overlay1Long
                                },
                                pto2: {
                                    lat: parseFloat(config.overlay2Lat),
                                    lng: parseFloat(config.overlay2Long)
                                }
                            },
                            bound: {
                                sw: {
                                    lat: parseFloat(config.bound2Lat),
                                    lng: parseFloat(config.bound2Long)
                                },
                                ne: {
                                    lat: parseFloat(config.bound1Lat),
                                    lng: parseFloat(config.bound1Long)
                                }
                            }
                        }

                        setGoogleConfig(_googleConfig);
                        props.setMapConfig(path, _googleConfig);
                    }

                })
                .catch(ex => {
                    console.log(ex);
                });
        }
    }

    return (
        <div>
            {loading && showLoader()}
            <Row>
                <Col md="12">
                    { componentState && <ActivityList path={path} isExtraordinary={isExtraordinary} /> }
                </Col>
            </Row>
        </div>
    );
}

const mapStateToProps = _ => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setForm,
    setApp,
    setMapConfig,
    setViewMode,
    setLoading
});

export default connect(mapStateToProps, mapActionsToProps)(Activity)

